import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "calendar-day__day" }
const _hoisted_2 = {
  key: 0,
  class: "calendar-day__price-tendency"
}
const _hoisted_3 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_4 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_5 = {
  key: 1,
  class: "calendar-day__info"
}
const _hoisted_6 = ["v-if"]
const _hoisted_7 = ["v-if"]
const _hoisted_8 = {
  key: 0,
  class: "d-none d-md-inline"
}
const _hoisted_9 = {
  key: 1,
  class: "d-none d-md-inline"
}
const _hoisted_10 = ["aria-label", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-day", {
          'is-selected-start-day' : _ctx.isSelectedStartDay,
          'is-selected-end-day' : _ctx.isSelectedEndDay,
          'is-disabled': _ctx.isDisabled,
          'is-fake-disabled': _ctx.hasDisabledLook,
          'is-in-range': _ctx.isInRange
        }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectDate(_ctx.day)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.getDay(_ctx.day.date)), 1),
    (!_ctx.hideTendency)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["status", _ctx.getPriceTendencyStatus])
          }, null, 2),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.getPriceTendencyName(_ctx.day.priceTendency)), 1))
            : _createCommentVNode("", true),
          (_ctx.isMobile && _ctx.getMobilePriceTendency())
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.getMobilePriceTendency()), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == 'activity')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(["d-md-none", _ctx.getSoldout() ? 'calendar-day__info__status is-soldout' : '']),
            "v-if": _ctx.getSoldout()
          }, null, 10, _hoisted_6),
          _createElementVNode("span", {
            class: "d-none d-md-inline",
            "v-if": _ctx.getSoldout()
          }, _toDisplayString(_ctx.getSoldout() ? _ctx.translate('shop.configuration.date.fully booked') : ''), 9, _hoisted_7),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.hasAvailabilities() ? 'calendar-day__info__status is-' + _ctx.day.availability.status : '')
          }, null, 2),
          (!_ctx.isTimeList)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.hasAvailabilities() ? _ctx.day.availability.total + ' ' + _ctx.translate('shop.configuration.date.available') : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isTimeList)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.hasAvailabilities() ? _ctx.day.availability.total + ' ' + _ctx.translate('shop.configuration.date.dates available') : ''), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideSeason)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["calendar-day__season", _ctx.day.season]),
          "aria-label": _ctx.day.season,
          title: _ctx.day.season
        }, null, 10, _hoisted_10))
      : _createCommentVNode("", true)
  ], 2))
}